import CommentSchema from 'Shared/utils/normalizeJSON/schemas/Comment.schema';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

import { showNotificationError } from 'Shared/helpers';

import CommentsConstants from '../constants/Comments.constants';
import {
  createComment as createCommentAPI,
  updateComment as updateCommentAPI,
  deleteComment as deleteCommentAPI,
  CreateCommentParams,
} from '../api/Comments.api';

export const createCommentSuccess = payload => ({
  type: CommentsConstants.Actions.CREATE_COMMENT_SUCCESS,
  payload,
});

export const deleteCommentSuccess = slug => ({
  type: CommentsConstants.Actions.DELETE_COMMENT_SUCCESS,
  payload: slug,
});

export const updateCommentSuccess = payload => ({
  type: CommentsConstants.Actions.UPDATE_COMMENT_SUCCESS,
  payload,
});

export const createComment =
  ({ record, parentId, payload }: CreateCommentParams) =>
  dispatch => {
    return createCommentAPI({ record, parentId, payload })
      .then(response => {
        dispatch(createCommentSuccess(normalizer(CommentSchema, response.data)));
        return response;
      })
      .catch(error => {
        showNotificationError(error);
      });
  };

export const deleteComment = commentSlug => dispatch => {
  return deleteCommentAPI(commentSlug)
    .then(response => {
      dispatch(deleteCommentSuccess(commentSlug));
      return response;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const updateComment = data => dispatch => {
  return updateCommentAPI(data)
    .then(response => {
      dispatch(updateCommentSuccess(normalizer(CommentSchema, response.data)));
      return response;
    })
    .catch(error => {
      showNotificationError(error);
    });
};
